import { Box, Select, MenuItem, SelectChangeEvent, Typography } from "@mui/material";
import ChevronDownIcon from "assets/icons/ChevronDown";

interface RowsPerPageSelectorProps {
  limit: number;
  onLimitChange: (event: SelectChangeEvent<number>) => void;
}

const RowsPerPageSelector = ({ limit, onLimitChange }: RowsPerPageSelectorProps) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
    }}>
      <Typography variant="p3" sx={{mr: 1.5}}>Количество на странице</Typography>
      <Select
        value={limit}
        onChange={onLimitChange}
        size="small"
        IconComponent={ChevronDownIcon}
        sx={{
          mr: 3,
          backgroundColor: 'background.paper',
          '& .MuiOutlinedInput-input.MuiSelect-select': {
            p: 1,
            pr: 4
          },
          '& .MuiSelect-icon': {
            right: 8
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          }
        }}
      >
        {[10, 20, 50].map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default RowsPerPageSelector;
